import Model from 'ampersand-model';

export default Model.extend({
	idAttribute: 'id',
	props: {
		id: 'string',
		title: 'string',
		body: 'string',
		href: 'string'
	}
});


// WEBPACK FOOTER //
// ./src/models/ExhibitElementModel.js